
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/lists",
      function () {
        return require("private-next-pages/user/lists/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/lists"])
      });
    }
  